<script>
import Main from './main.vue';
import Api from '@/utils/api';

export default Main.extend({
  methods: {
    getData() {
      return Api.dashboard.getVendorKpi.language(this.ajaxParams).then((resp) => {
        if (resp.data.Data) {
          return [
            {
              name: 'Source language(s)',
              data: [{
                x: 0,
                y: 1,
                data: resp.data.Data.SourceLanguageCount,
              }],
            },
            {
              name: 'Target language(s)',
              data: [{
                x: 1,
                y: 1,
                data: resp.data.Data.TargetLanguageCount,
              }],
            },
            {
              name: 'Language pairs',
              data: [{
                x: 2,
                y: 1,
                data: resp.data.Data.LanguageCombinationsCount,
              }],
            },
          ];
        }
      });
    },
  },
});
</script>
